export default __webpack_public_path__ + "static/php-original-1e73afc4967ab2fe950ba75b323d73b4.svg";